import { Authentication, APIList } from '@/api';
import $ from 'jquery';
import Cookies from 'js-cookie'
import Vue from 'vue'



const api = new APIList();
const authAPI = new Authentication();

export default {
  fileDownload({ state }, ID) {
    return new Promise((resolve, reject) => {
      api.fileDownload(ID,
        (json) => {
          resolve(json);
        },
        (err) => {
          reject(err);
        })
    })
  },

  getAllSelections({ commit }, selectionType) {
    return new Promise((resolve, reject) => {
      api.getAllSelections(selectionType,
        (json) => {
          resolve(json);
        },
        (err) => {
          reject(err);
        })
    })
  },

  searchOption({ commit }, payload) {

    var params = {
      type: payload.optionType,
      ...payload.searchInput
    }

    return new Promise((resolve, reject) => {
      api.autoSearch(payload.dest, params,
        (json) => {
          switch (json.status) {
            case 200:
              resolve(json.data.list);
              break;
            default:
              reject(json);
              break;
          }
        },
        (err) => {
          reject(err);
        })
    })
  },

  deleteDocument({ state }, ID) {
    return new Promise((resolve, reject) => {
      api.fileDelete(ID, (json) => {
          switch (json.status) {
            case 200:
              resolve(json);
              break;
            default:
              reject(json);
              break;
          }
        },
        (err) => {
          reject(err);
        })
    })
  },

  getExchangeRate({state,commit}) {
    return new Promise((resolve, reject) => {
      api.getExchangeRate((json) => {
          switch (json.status) {
            case 200:
              commit('updateExchangeRate', json.data.rate);
              resolve(json);
              break;
            default:
              reject(json);
              break;
          }
        },
        (err) => {
          reject(err);
        })
    })
  },

  getUserAddress({ state }, param) {
    return new Promise((resolve, reject) => {
      api.getUserAddress(param, (json) => {
        if (json.status !== 200) {
          reject(json.message);
        }
        resolve(json);
      }, (error) => {
        reject(error);
      })
    });
  },
  addProductToCart({ state, commit, getters }, product) {
    let cart = Array.from(state.cartProducts);
    cart = JSON.parse(JSON.stringify(cart))
    let imageUrl = getters.getImageUrl(product.imageMain);
    // let exchangePrice = getters.getExchangePrice(product.marketPrice);
    let selectedProductAttribute = {}
    if(product.attributeVariation){
      for(let i=0; i<product.attributeVariation.length; i++){
        if(product.attributeVariation[i].ID == product.selectedProduct){
          selectedProductAttribute = product.attributeVariation[i]
        }
    }
    };
    let item = {
      ID: product.ID,
      attributeID: product.selectedProduct? product.selectedProduct : '',
      nameHk: product.nameHk,
      nameCn: product.nameCn,
      imageMain: product.imageMain,
      quantity: parseInt(product.quantity),
      category1: product.attributeCategory1? product.attributeCategory1 : '',
      category2: product.attributeCategory2? product.attributeCategory2 : '',
      attribute1: selectedProductAttribute.attribute1? selectedProductAttribute.attribute1 : '',
      attribute2: selectedProductAttribute.attribute2? selectedProductAttribute.attribute2 : ''
    };
    if(Object.keys(selectedProductAttribute).length !== 0){
      if(Cookies.get('redirect') == 'false'){
        item.unitPrice = selectedProductAttribute.price
      }else if(Cookies.get('redirect') == 'true' && product.originalPrice !== "0"){
        item.unitPrice = product.originalPrice
      }else{
        item.unitPrice = selectedProductAttribute.price
      }
    }else{
      if(Cookies.get('redirect') == 'false'){
        item.unitPrice = product.marketPrice
      }else if(Cookies.get('redirect') == 'true' && product.originalPrice !== "0"){
        item.unitPrice = product.originalPrice
      }else{
        item.unitPrice = product.marketPrice
      }
    }
    let dummy = 0;

    if (product.productID) { // KOLProduct
      item.kolProductID = product.ID; // KOLProductID
      item.productID = product.productID; // ProductID
      for(var i=0;i<cart.length;i++){
        if(cart[i].productID == product.productID && cart[i].attributeID == product.selectedProduct){
          cart[i].quantity += 1;
          dummy = 1
        }else if(cart[i].productID == product.productID && product.attributeVariation.length == 0){
          cart[i].quantity += 1;
          dummy = 1
        }
      }
    } else { // Fullist Product
      item.kolProductID = product.kolProductID // No KOLProductID
      item.productID = product.ID; //  productID
      for(var i=0;i<cart.length;i++){
        if(cart[i].productID == product.ID && cart[i].attributeID == product.selectedProduct){
          cart[i].quantity += 1;
          dummy = 1;
        }else if(cart[i].productID == product.ID && product.attributeVariation.length == 0){
          cart[i].quantity += 1;
          dummy = 1;
        }
      }
    }
    if(dummy == 0){
      cart.push(item);
    }
    commit('addCartProduct', cart);
    commit('updateLocalStorageCartList');
  },
  addPackagesToCart({ state, commit, getters }, packages) {

    let cart = [];
    let imageUrl = getters.getImageUrl(packages.imageMain);
    // let exchangePrice = getters.getExchangePrice(packages.marketPrice);
    let item = {
      nameHk: packages.nameHk,
      nameCn: packages.nameCn,
      imageMain: packages.imageMain,
      unitPrice: packages.marketPrice,
      quantity: parseInt(packages.quantity),
    };

    if (packages.productID) { // KOLProduct
      item.productID = packages.productID; // KOLProductID
      item.kolProductID = packages.ID; // ProductID
    } else { // Fullist Product
      item.productID = packages.ID // No KOLProductID
      item.kolProductID = packages.kolProductID; //  productID
    }
    cart.push(item);
    commit('setCartPackages', cart);
    commit('updateLocalStorageCartList');
  },
  updateProductInCart({ state, commit, getters }, product) {
    
    let cart = Array.from(state.cartProducts);
    $.each(cart, (index, item) => {
      let productID;
      let KPID;
      if (product.productID) { // KOLProduct
        productID = product.productID;
        KPID = product.ID;
      } else { // Fullist Product
        productID = product.ID;
      }
      if (item.productID == productID) {
        if (KPID) {
            commit('updateCartProductKPID', { index: index, ID: KPID })
          }
        if(product.attributeID){
          commit('updateCartProductQuantity', { 
            index: index,
            ID: product.ID, 
            quantity: product.quantity, 
            selectedProduct: product.attributeID});
          }else{
            commit('updateCartProductQuantity', { index: index, quantity: product.quantity });
          }
        }
    });
        commit('updateLocalStorageCartList');
  },
  updatePackagesInCart({ state, commit, getters }, packages) {
      let productID;
      let KPID;
      if (packages.kolProductID) { // KOLProduct
        productID = packages.kolProductID;
        KPID = packages.ID;
      } else { // Fullist Product
        productID = packages.ID;
      }
    if (KPID) {
        commit('updateCartPackagesKPID', { index: 0, ID: KPID })
      }
        commit('updateCartPackagesQuantity', { index: 0, quantity: packages.quantity });
        commit('updateLocalStorageCartList');
  },
  removeCartProduct({state,commit},product){
    commit('removeCartProduct', product);
    commit('updateLocalStorageCartList');

  },
  clearShoppingCart({state,commit}){
        commit('clearShoppingCart');
        Vue.localStorage.set('cartProducts', "[]");
        Vue.localStorage.set('cartToken', Cookies.get('token'));

  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js